function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import ServiceFactory from "../../service";
import { Card, Empty, Pending } from "../../components/analytics-kit";
import { nameOf, initialsOf } from "./collab";

/*
 * My work (PlunkDocs specs/CONTENT_HUB_REVIEW_DESK_2026-10-21.md §4.5, mockup D): across stories, what is mine to do.
 * GET /content/my-work: pieces assigned to me (late first), reviews waiting on me, mentions in open threads, my pieces
 * that came back with changes, and what I finished this week. Each row opens the piece in the Builder.
 */
const svc = api => {
  const S = ServiceFactory.getType(api, "product");
  return new S();
};
const cap = s => String(s || "").replace(/^./, c => c.toUpperCase());
const day = d => d ? new Date(String(d).length === 10 ? d + "T12:00" : d).toLocaleDateString([], {
  month: "short",
  day: "numeric"
}) : "";
export default class MyWork extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      data: null,
      error: false,
      team: null,
      saving: false
    });
    _defineProperty(this, "setPolicy", async on => {
      this.setState({
        saving: true
      });
      try {
        await svc("/content/review-policy").putAsync({
          moderatorApproval: on
        });
        if (this._alive) this.setState({
          team: {
            ...this.state.team,
            moderatorApproval: on
          }
        });
      } catch (e) {/* keep */}
      if (this._alive) this.setState({
        saving: false
      });
    });
    _defineProperty(this, "load", async () => {
      try {
        const r = await svc("/content/my-work").getAsync();
        if (this._alive) this.setState({
          data: r || {},
          error: false
        });
      } catch (e) {
        if (this._alive) this.setState({
          data: {},
          error: true
        });
      }
    });
    _defineProperty(this, "open", piece => {
      if (piece && piece.link) this.props.history.push(piece.link);
    });
  }
  componentDidMount() {
    this._alive = true;
    this.load();
    svc("/content/team").getAsync().then(t => this._alive && this.setState({
      team: t
    })).catch(() => {});
  }
  renderPolicy() {
    const t = this.state.team;
    if (!t) return null;
    return /*#__PURE__*/React.createElement(Card, {
      title: "Who approves",
      hint: "for every story in this workspace",
      span: 6
    }, t.moderator ? /*#__PURE__*/React.createElement("label", {
      className: "mw-policy"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: !!t.moderatorApproval,
      disabled: this.state.saving,
      onChange: e => this.setPolicy(e.target.checked)
    }), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, "Moderators approve"), /*#__PURE__*/React.createElement("i", null, "When on, only owners, administrators and moderators approve pieces; everyone else asks for a review. When off, anyone can approve."))) : /*#__PURE__*/React.createElement("p", {
      className: "mw-policy-note"
    }, t.moderatorApproval ? "A moderator approves pieces in this workspace. Ask for a review when a piece is ready." : "Anyone can approve pieces in this workspace."));
  }
  componentWillUnmount() {
    this._alive = false;
  }
  row(key, piece, side, extra, tone) {
    if (!piece) return null;
    return /*#__PURE__*/React.createElement("button", {
      key: key,
      type: "button",
      className: "mw-row",
      onClick: () => this.open(piece)
    }, /*#__PURE__*/React.createElement("span", {
      className: "mw-main"
    }, /*#__PURE__*/React.createElement("b", null, piece.title || cap(piece.kind)), /*#__PURE__*/React.createElement("i", null, cap(piece.kind), " \xB7 ", piece.story), extra ? /*#__PURE__*/React.createElement("span", {
      className: "mw-extra"
    }, extra) : null), /*#__PURE__*/React.createElement("span", {
      className: "mw-side" + (tone ? " " + tone : "")
    }, side));
  }
  section(title, hint, rows, empty) {
    return /*#__PURE__*/React.createElement(Card, {
      title: title,
      hint: hint,
      span: 6
    }, rows.length ? /*#__PURE__*/React.createElement("div", {
      className: "mw-list"
    }, rows) : /*#__PURE__*/React.createElement(Empty, null, empty));
  }
  render() {
    const {
      data,
      error
    } = this.state;
    if (!data) return /*#__PURE__*/React.createElement("div", {
      className: "wa-grid"
    }, /*#__PURE__*/React.createElement(Card, {
      title: "My work"
    }, /*#__PURE__*/React.createElement(Pending, null)));
    if (error) return /*#__PURE__*/React.createElement(Empty, null, "My work could not be loaded. Try again in a moment.");
    const assigned = data.assigned || [];
    const reviews = data.reviews || [];
    const mentions = data.mentions || [];
    const changes = data.changes || [];
    const done = data.doneThisWeek || [];
    const late = assigned.filter(a => a.late).length;
    return /*#__PURE__*/React.createElement("div", {
      className: "wa-grid mw-grid"
    }, this.section("Assigned to you", assigned.length ? `${assigned.length}${late ? ` · ${late} late` : ""}` : null, assigned.map((a, i) => this.row(`a${i}`, a.piece, a.due ? a.late ? `Late · ${day(a.due)}` : `Due ${day(a.due)}` : "No due date", `${a.role === "media" ? "Pictures" : "Words"}${a.by ? ` · from ${nameOf(a.by)}` : ""}`, a.late ? "bad" : "")), "Nothing assigned to you right now."), this.section("Reviews waiting on you", reviews.length ? String(reviews.length) : null, reviews.map((r, i) => this.row(`r${i}`, r.piece, r.changedSince ? "Changed since your last look" : r.required ? "Required" : "Optional", null, r.changedSince ? "info" : "")), data.reviewsAvailable === false ? "Reviews aren't switched on for this workspace yet." : "No reviews waiting on you."), this.section("Came back with changes", changes.length ? String(changes.length) : null, changes.map((c, i) => this.row(`c${i}`, c.piece, nameOf(c.by), c.note ? `"${String(c.note).slice(0, 140)}"` : null, "warn")), "None of your pieces were sent back."), this.section("Mentions", mentions.length ? String(mentions.length) : null, mentions.map((m, i) => m.piece ? this.row(`m${i}`, m.piece, day(m.at), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "bm-av mw-av"
    }, initialsOf(m.by)), m.byName || nameOf(m.by), ": ", String(m.text || "").slice(0, 140))) : null).filter(Boolean), "No open threads mention you."), this.section("Done this week", done.length ? String(done.length) : null, done.map((d, i) => this.row(`d${i}`, d.piece, d.what, null, d.what === "Approved" || d.what === "Signed off" ? "ok" : "")), "Sign-offs and approved pieces from the last 7 days show here."), this.renderPolicy());
  }
}